export default function maybe<T>(attempt: () => T, fallback: T): T {
  try {return attempt()}
  catch (e) {return fallback}
}